export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 90,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_label_fabric_img') || '图片',
    field: 'fabricImg',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'fabricImg' },
  },
  {
    title: that.$l('table_label_fabric_color') || '面料颜色',
    field: 'fabricColor',
    minWidth: 130,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabricColor' },
  },
  {
    field: 'demandQty',
    minWidth: 140,
    title: that.$l('table_label_demandQty') || '需求数量',
    headerAlign: 'center',
    align: 'center',
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        max: 999999,
        step: 1,
        'controls-position': 'right',
      },
    },
    formatter: ({ row }) => {
      const { demandQty: value } = row
      return that.format(value)
    },
  },
  {
    field: 'unitPrice',
    minWidth: 140,
    title: that.$l('INDEX.choose_fabric_price') || '单价',
    headerAlign: 'center',
    align: 'center',
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 99999999.99,
        step: 0.01,
        'controls-position': 'right',
      },
    },
    formatter: ({ row }) => {
      const { unitPrice: value } = row
      return that.format(value)
    },
  },
  {
    title: that.$l('table_label_demandAmount') || '小计金额',
    field: 'demandAmount',
    minWidth: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'demandAmount' },
  },
]
